import React from "react";

import "./AddNewDevice.css";
import AddNewDeviceForm from "./form/AddNewDeviceForm";
import { CHANGE_DEVICE_ALERT } from "static/constants";
import { Alert } from "@mui/material";
import ModalWrapper from "../modalWrapper/ModalWrapper";

const AddNewDeviceModal = (props) => {
  const { onClose, isModalOpen } = props;

  const handleClose = (_event, reason) => {
    if (reason && reason === "backdropClick") return;
    onClose();
  };

  return (
    <ModalWrapper
      show={isModalOpen}
      onClose={handleClose}
      disableEnforceFocus
      title="Add New Device"
    >
      <div className="mt-2 mb-2">
        <Alert severity="warning" className="mb-3">
          {CHANGE_DEVICE_ALERT}
        </Alert>
      </div>
      <div className="mt-3">
        <AddNewDeviceForm {...props} />
      </div>
    </ModalWrapper>
  );
};

export default AddNewDeviceModal;
